// @flow
import * as React from "react";

import Card from "../Card";
import sharedStyles from "../DashboardSummary/shared/Shared.scss";
import LabeledContent from "../DashboardSummary/LabeledContent";

import styles from "./ContactPerson.scss";

type ContactPersonProps = {
  bank: string,
  contactPerson: string,
  phone: string,
  additionalCardStyles: string,
  title: string,
  email: string,
  contactPersonType: "bank" | "guaranteeBank"
};

export default function ContactPerson({
  bank,
  contactPerson,
  phone,
  additionalCardStyles,
  title,
  email,
  contactPersonType
}: ContactPersonProps) {
  return (
    <Card additionalCardStyles={additionalCardStyles}>
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.content}>
        <div className={sharedStyles.col}>
          <div className={sharedStyles.col}>
            <LabeledContent
              label={contactPersonType === "guaranteeBank" ? "Bürgschaftsbank" : "Bank"}
            >
              {bank}
            </LabeledContent>
          </div>
          <div className={sharedStyles.col}>
            <LabeledContent label="Ansprechpartner">{contactPerson}</LabeledContent>
          </div>
          <div className={sharedStyles.col}>
            <LabeledContent label="Telefon">{phone}</LabeledContent>
          </div>
          <div className={sharedStyles.col}>
            <LabeledContent label="Mail">{email}</LabeledContent>
          </div>
        </div>
      </div>
    </Card>
  );
}
